import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useMemo} from 'react'
import {useLocation} from 'react-use'
import {branch, compose} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import {getGradeScore} from 'views/AppLocals/Course'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {NullAsDefault} from 'views/Shared'
import {withReportTable} from 'views/Workspace/Examination/renderReportTable'
import {useRouteSearchParam} from "../../../../envs/_current/history";
import {course_getGradeTrackingSheetReport_Api} from "../../../../apis";
import CourseClassStudentGradeSheetReportFilter from "../components/filters/CourseClassStudentGradeSheetReportFilter";
import {renderIfElse} from "../../../Shared";
import Translate from "../../../../modules/local/Translate";

const headers = ['grades', 'score weight', 'score', 'score 1', 'score 2']

const schemas = [
    {
        name: 'title',
        value_path: 'title',
        className: 'font-medium text-color-000 whitespace-no-wrap',
    },
    {
        name: 'score_weight',
        value_path: 'score_weight',
        className: 'text-color-100',
        width: 100,
        render: (value) => {
            return <span className="font-semibold">{value}</span>
        },
    },
    {
        name: 'score',
        value_path: 'score_type',
        className: 'text-color-100',
        width: 100,
        render: (value, data) => {
            const score = getGradeScore(data)
            return (
                <Translate>
                    {t => (
                        renderIfElse(
                            !!!_.get(data, 'grade_date'),
                            <span className="font-normal text-xs text-color-400 italic capitalize">{t('not update')}</span>,
                            <span className="font-semibold">{score}</span>
                        )
                    )}
                </Translate>
            )
        },
    },
    {
        name: 'score_1',
        value_path: 'score_type',
        className: 'text-color-100',
        width: 100,
        render: (value, data) => {
            const score = getGradeScore(data, 1);
            if (!!!_.get(data, 'grade_1_date')) return " - ";
            return <span className="font-semibold">{score}</span>
        },
    },
    {
        name: 'score_2',
        value_path: 'score_type',
        className: 'text-color-100',
        width: 100,
        render: (value, data) => {
            const score = getGradeScore(data, 2)
            if (!!!_.get(data, 'grade_2_date')) return " - ";
            return <span className="font-semibold">{score}</span>
        },
    },
]

const CourseClassStudentGradeSheetReport = ({
                                                owner_id,
                                                owner_type,
                                                filter_actions = {
                                                    sortBy: 'sort-by',
                                                    keyword: 'keyword',
                                                    course_id: 'course-id',
                                                    subject_id: 'subject-id',
                                                    student_id: 'student-id',
                                                    course_class_id: 'class-id',
                                                },
                                            }) => {
    const t = useTranslate()

    const location = useLocation()

    const sortBy = useRouteSearchParam(filter_actions.sortBy)

    const course_id = useRouteSearchParam(filter_actions.course_id)

    const subject_id = useRouteSearchParam(filter_actions.subject_id)

    const student_id = useRouteSearchParam(filter_actions.student_id)

    const course_class_id = useRouteSearchParam(filter_actions.course_class_id)

    const refresh_deps = useMemo(
        () => [
            owner_id,
            owner_type,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [owner_id, owner_type, location.state]
    )

    const [pager_widget, {widget_header}] = usePaginationHelper({
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onSortChange(sortBy)
            onFilterChange({
                course_id,
                subject_id,
                student_id,
                course_class_id,
            })
        },
        pagerInfo: {
            query: bindQueryParams([
                {subject_id},
                {
                    student_id,
                },
                {
                    id: course_class_id,
                },
            ]),
            PaginationMeta: NullAsDefault,
            apiInfo: course_getGradeTrackingSheetReport_Api,
            ...withReportTable(headers, schemas),
        },
        withKey: createPagerKey(refresh_deps),
        dependencies: [owner_id, owner_type],
        filter_params: {
            owner_id,
            owner_type,
            course_id,
            student_id,
            course_class_id,
        },
        renderSortBy: NullAsDefault,
        SortByWidget: NullAsDefault,
        renderSearchBar: NullAsDefault,
        isToggleDefault: true,
        query_params: filter_actions,
        AdvancedFilter: CourseClassStudentGradeSheetReportFilter,
    })
    return (
        <div className="space-y-3">
            <div className="font-semibold text-primary tracking-wide uppercase">
                {t('report')}
            </div>
            <div className="border rounded-lg p-3">
                <div className="flex flex-col">
                    <div className="text-center font-bold text-lg text-color-000 uppercase tracking-widest mb-4">
                        {t('detail grade sheet by student')}
                    </div>
                    {subject_id && course_class_id && student_id ? pager_widget : widget_header}
                </div>
            </div>
        </div>
    )
}

export default compose(
    branch(
        ({owner_id, owner_type}) => _.some([owner_id, owner_type], _.isEmpty),
        () => () => <ContentNotFound/>
    )
)(CourseClassStudentGradeSheetReport)
